export const style = {
  typographyStatus: {
    sx: {
      color: 'action.active',
      lineHeight: 2,
    },
  },
  box: {
    sx: {
      display: 'flex',
      alignItems: 'start',
      color: 'action.active',
      gap: 1,
      pt: 1,
      pb: 0,
      svg: {
        fill: '#F1C40F',
      },
    },
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
} as const;
